export const APP_TIMELINE = {
  "Timeline.Bg.Color": {
    defaultValue: "transparent"
  },
  "Timeline.Border.Top.Left.Radius": {
    defaultValue: "0"
  },
  "Timeline.Border.Top.Right.Radius": {
    defaultValue: "0"
  },
  "Timeline.Border.Bottom.Left.Radius": {
    defaultValue: "0"
  },
  "Timeline.Border.Bottom.Right.Radius": {
    defaultValue: "0"
  },
  "Timeline.Border.Color": {
    defaultValue: "transparent"
  },
  "Timeline.Border.Left.Width": {
    defaultValue: "0"
  },
  "Timeline.Border.Top.Width": {
    defaultValue: "0"
  },
  "Timeline.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Timeline.Border.Right.Width": {
    defaultValue: "0"
  },
  "Timeline.Padding.Top": {
    defaultValue: "0"
  },
  "Timeline.Padding.Right": {
    defaultValue: "0"
  },
  "Timeline.Padding.Bottom": {
    defaultValue: "0"
  },
  "Timeline.Padding.Left": {
    defaultValue: "0"
  },
  "Timeline.Shadow": {
    defaultValue: "none"
  },
  "Timeline.Column.Header.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Timeline.Column.Title.Color": {
    ref: "Color.Gray.900"
  },
  "Timeline.Column.Header.Hover.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Timeline.Holiday.Bg.Color": {
    ref: "Colog.Gray.200"
  },
  "Timeline.Taskbar.Overdue.Bg.Color": {
    ref: "Color.Secondary.Four.400"
  },
  "Timeline.Taskbar.ParentItem.Bg.Color": {
    ref: "Color.Secondary.One.400"
  },
  "Timeline.Taskbar.Subitem.Bg.Color": {
    ref: "Color.Secondary.Six.400"
  },
  "Timeline.Taskbar.Nodates.Bg.Color": {
    ref: "Color.Gray.400"
  },
  "Timeline.Row.Color": {
    ref: "Color.Gray.900"
  },
  "Timeline.Row.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Timeline.Row.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Timeline.Row.Border.Color": {
    ref: "Color.Gray.200"
  },
  "Timeline.Row.Border.Weight": {
    defaultValue: "1px"
  },
  "Timeline.Width": {
    defaultValue: "100%"
  },
  "Timeline.Height": {
    defaultValue: "750px"
  },
  "Timeline.Overflow": {
    defaultValue: "hidden"
  },
  "Timeline.Min.Height": {
    defaultValue: "0"
  },
  "Timeline.Max.Height": {
    defaultValue: "unset"
  },
  "Timeline.Min.Width": {
    defaultValue: "750px"
  },
  "Timeline.Max.Width": {
    defaultValue: "unset"
  }
};
